import React from 'react';
import { BookOpenIcon, GiftIcon, MapIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '4 exclusive bonuses'
}, {
  icon: MapIcon,
  label: '+400 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and professionals'
}];
export function SocialProof() {
  return <section className="border-y-2 border-forestDeep bg-forest py-5" aria-label="What the teacher ready includes" data-id="element-216" data-mp="3f4v8hstarjc">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-cream sm:justify-between" data-id="element-217" data-mp="8ehkf975oap3">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-218" data-mp="3usr6vcriz8n8">
            <Icon className="h-5 w-5 text-goldBright" aria-hidden="true" data-id="element-219" data-mp="mdzbxwbu6225" /> {label}
          </span>)}
      </div>
    </section>;
}